import React from "react";
import { DialogTitle } from "@mui/material";

const DSDialogTitle = (props: React.ComponentProps<typeof DialogTitle>) => {
  return <DialogTitle {...props} fontFamily={"Gilroy-Bold"} />;
};

export default DSDialogTitle;
